module.exports = __webpack_public_path__ + "img/azo-tag-logo.560392cc.png";